import React from "react";
import { StockProvider } from "../Context/StockContext";
import StockContent from "./Stocks/StockContent";

const Stock = () => {
  return (
    <StockProvider>
      <StockContent />
    </StockProvider>
  );
};

export default Stock;